<template>
  <div v-if="visible" class="modal-overlay">
    <div class="modal-content">
      <div class="modal-banner">
        <h3>{{ title }}</h3>
        <button class="close-button" @click="closeModal"><img src = "../assets/art/X_btn.png"></button>
      </div>
      <h2 class="modal-title">{{ title }}</h2>
      <div class="modal-body">
        
        <p class="description">{{ description }}</p>
      </div>
      <div class="button-container">
        <button 
            v-for="answer in answers"
            class="place-block-button" 
            :key="answer.title"
            :data-is-correct="answer.isCorrect"
            @click="handleAnswerClick"
            >{{ answer.title }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalPopup',
  props: {
    visible: {
        type: Boolean,
        required: false,
    },
    title: {
        type: String,
        default: 'Modal Title',
    },
    description: {
        type: String,
        default: 'This is a description for the modal popup.',
    },
    answers:{
        type: Array,
        default: ()=>[
            {
                title:"Answer 1",
                isCorrect:false
            },
            {
                title:"Answer 2",
                isCorrect:true
            },
            {
                title:"Answer 3",
                isCorrect:false
            },
        ]
    }
  },
  emits: ['close'],
  methods: {
    closeModal() {
      this.$emit('close');
    },
    handleAnswerClick(e){
        console.log(e.target)
        if(e.target.getAttribute("data-is-correct")){
            this.$emit('answered-correct')
        }
        else{
            e.target.style.border='solid 2px red';
        }
    }
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal-content {
  background: white;
  border-radius: 3px;
  width: 90%;
  max-width: 1000px;
  overflow: hidden;
  position: relative;
  padding: 0;
}

.modal-banner {
  background-image: url('../assets/art/popup_header02.png');
  height: 50px;
  position: relative;
  display:flex;
  justify-content:space-between;
  align-items:center;
}
.modal-banner h3{
    margin-left:3%;
    position:static;
    color:white;
}


.close-button {
  position: static;
  margin-right:20px;
  font-size: 24px;
  background: none;
  border: none;
  color: white;
  cursor: pointer;
}

.close-button img{
  width:13px;
}

.modal-title {
  text-align: center;
  margin: 16px 0;

}

.modal-body {
    padding: 0 20px 20px;
    text-align: center;
    display:flex;
    flex-flow: row nowrap;
    gap: 1rem;
}

.video-wrapper {
    width:100%
}

.video-wrapper iframe {
  width: 100%;
  height: 315px;
}

.description {

  font-size: 16px;
  width:100%;
  text-align: left;
  margin: 15px 15%;
}

.button-container {
    display: flex;
    flex-flow: row nowrap;
    gap: 30px;
    justify-content: center;

}

.place-block-button {
    display: block;
    margin: 0 auto 20px;
    background-color: #4a2a00;
    color: white;
    border: none;
    padding: 7px 60px;
    font-size: 1.1rem;
    cursor: pointer;
    border-radius: 16px;
    transition: background-color 0.3s ease;
    font-family: Verdaguera, serif;
}
</style>
